module.exports = __webpack_public_path__ + "img/diners.47125726.png";